import React from 'react';
import { Award, Calendar, CheckCircle } from 'lucide-react';
import { companyInfo } from '../mock';

export const Certificate = ({ course, studentName = "John Doe" }) => {
  return (
    <div className="relative bg-gradient-to-br from-white to-gray-50 border-8 border-double border-orange-300 rounded-2xl p-8 shadow-2xl overflow-hidden">
      {/* Watermark Logo */}
      <div className="absolute inset-0 flex items-center justify-center opacity-5 pointer-events-none">
        <img 
          src={companyInfo.logoUrl} 
          alt="Phoenix Logo Watermark" 
          className="h-64 w-64 object-contain"
        />
      </div>
      
      {/* Certificate Header */}
      <div className="relative z-10 text-center mb-8">
        <div className="flex items-center justify-center mb-4">
          <img 
            src={companyInfo.logoUrl} 
            alt="Phoenix Well Control Academy" 
            className="h-16 w-16 object-contain mr-4"
          />
          <div>
            <h1 className="text-2xl font-black bg-gradient-to-r from-orange-600 to-yellow-600 bg-clip-text text-transparent">
              PHOENIX WELLCONTROL
            </h1>
            <p className="text-orange-600 font-bold text-sm tracking-wider">ACADEMY</p>
          </div>
        </div>
        
        <div className="border-t-2 border-b-2 border-orange-300 py-3 mb-6">
          <h2 className="text-3xl font-bold text-gray-800 mb-2">CERTIFICATE OF COMPLETION</h2>
          <p className="text-gray-600 text-sm">This is to certify that</p>
        </div>
      </div>

      {/* Student Name */}
      <div className="relative z-10 text-center mb-6">
        <div className="border-b-2 border-gray-300 pb-2 mb-4 mx-8">
          <h3 className="text-2xl font-bold text-gray-800 italic">{studentName}</h3>
        </div>
        <p className="text-gray-600 text-sm">has successfully completed the training program</p>
      </div>

      {/* Course Details */}
      <div className="relative z-10 text-center mb-8">
        <div className="bg-gradient-to-r from-orange-50 to-yellow-50 border border-orange-200 rounded-xl p-6 mx-4">
          <h4 className="text-xl font-bold text-gray-800 mb-3 leading-tight">
            {course.title}
          </h4>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
            <div className="flex items-center justify-center space-x-2">
              <Calendar className="h-4 w-4 text-orange-600" />
              <span className="text-gray-700">
                <strong>Duration:</strong> {course.duration}
              </span>
            </div>
            
            <div className="flex items-center justify-center space-x-2">
              <CheckCircle className="h-4 w-4 text-green-600" />
              <span className="text-gray-700">
                <strong>Format:</strong> {course.format}
              </span>
            </div>
            
            <div className="flex items-center justify-center space-x-2">
              <Award className="h-4 w-4 text-purple-600" />
              <span className="text-gray-700">
                <strong>Valid:</strong> 2 Years
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Signature Section */}
      <div className="relative z-10 grid grid-cols-2 gap-8 text-center">
        <div>
          <div className="border-b border-gray-400 mb-2 pb-1">
            <p className="text-sm text-gray-500 mb-8">Date of Completion</p>
            <p className="text-gray-700 font-semibold">{new Date().toLocaleDateString()}</p>
          </div>
        </div>
        
        <div>
          <div className="border-b border-gray-400 mb-2 pb-1">
            <p className="text-sm text-gray-500 mb-8">Authorized Signature</p>
            <p className="text-gray-700 font-semibold italic">Training Director</p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="relative z-10 text-center mt-8 pt-6 border-t border-orange-200">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-xs text-gray-600">
          <div>
            <p className="font-semibold">Contact:</p>
            <p>{companyInfo.phone}</p>
          </div>
          <div>
            <p className="font-semibold">Email:</p>
            <p>{companyInfo.email}</p>
          </div>
          <div>
            <p className="font-semibold">Location:</p>
            <p>{companyInfo.location}</p>
          </div>
        </div>
        
        <div className="mt-4 pt-4 border-t border-orange-100">
          <p className="text-xs text-gray-500 italic">
            "Building Competence, Securing Wells" - Registered Training Institute in Gujarat, India
          </p>
        </div>
      </div>

      {/* Decorative Corner Elements */}
      <div className="absolute top-4 left-4 w-8 h-8 border-l-4 border-t-4 border-orange-400 rounded-tl-lg"></div>
      <div className="absolute top-4 right-4 w-8 h-8 border-r-4 border-t-4 border-orange-400 rounded-tr-lg"></div>
      <div className="absolute bottom-4 left-4 w-8 h-8 border-l-4 border-b-4 border-orange-400 rounded-bl-lg"></div>
      <div className="absolute bottom-4 right-4 w-8 h-8 border-r-4 border-b-4 border-orange-400 rounded-br-lg"></div>
    </div>
  );
};